module.exports = require("react-dev-utils/InterpolateHtmlPlugin");